import React from 'react'
import SearchResultsSection from './SearchResultsSection'
import SearchBar from './SearchBar'
import "../styles/SearchSection.css"

const SearchSection = ({completeConnection, setCompleteConnection, 
  searchQuery, setSearchQuery, handleSearchChange, searchResults, setSearchResults, handleSelectActor, connectedActors, actorPair}) => {
  return (
    <div className="search-wrapper">
      <SearchBar completeConnection={completeConnection} searchQuery={searchQuery} handleSearchChange={handleSearchChange} connectedActors={connectedActors}/>
      <SearchResultsSection searchResults={searchResults} handleSelectActor={handleSelectActor} connectedActors={connectedActors} actorPair={actorPair}/>
    </div>
      )
     
}

export default SearchSection